import { render, staticRenderFns } from "./TheThgProcessingList.vue?vue&type=template&id=31324bd4&scoped=true"
import script from "./TheThgProcessingList.vue?vue&type=script&lang=ts"
export * from "./TheThgProcessingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31324bd4",
  null
  
)

export default component.exports